import ViewSwitch from "@/components/common/ViewSwitch";
import { useJobViewStore } from "@/zustand/store";

const JOB_VIEW_OPTIONS = [
  {
    value: "sku",
    label: "SKU View",
  },
  {
    value: "styleId",
    label: "Style ID View",
  },
] as const;

export default function JobViewSwitch() {
  const { isAggregated, setIsAggregated } = useJobViewStore();

  return (
    <ViewSwitch
      options={JOB_VIEW_OPTIONS}
      value={isAggregated ? "styleId" : "sku"}
      onChange={(value) => setIsAggregated(value === "styleId")}
    />
  );
}
